export const GET_ADMIN_FILTER_PACKAGES = "GET_ADMIN_FILTER_PACKAGES";
export const GET_ADMIN_FILTER_PACKAGES_SUCCESS = "GET_ADMIN_FILTER_PACKAGES_SUCCESS";
export const GET_ADMIN_FILTER_PACKAGES_ERROR = "GET_ADMIN_FILTER_PACKAGES_ERROR";

export const POST_ADMIN_FILTER_PACKAGES = "POST_ADMIN_FILTER_PACKAGES";
export const POST_ADMIN_FILTER_PACKAGES_SUCCESS = "POST_ADMIN_FILTER_PACKAGES_SUCCESS";
export const POST_ADMIN_FILTER_PACKAGES_ERROR = "POST_ADMIN_FILTER_PACKAGES_ERROR";

export const UPDATE_ADMIN_FILTER_PACKAGES = "UPDATE_ADMIN_FILTER_PACKAGES";
export const UPDATE_ADMIN_FILTER_PACKAGES_SUCCESS = "UPDATE_ADMIN_FILTER_PACKAGES_SUCCESS";
export const UPDATE_ADMIN_FILTER_PACKAGES_ERROR = "UPDATE_ADMIN_FILTER_PACKAGES_ERROR";

export const DELETE_ADMIN_FILTER_PACKAGES = "DELETE_ADMIN_FILTER_PACKAGES";
export const DELETE_ADMIN_FILTER_PACKAGES_SUCCESS = "DELETE_ADMIN_FILTER_PACKAGES_SUCCESS";
export const DELETE_ADMIN_FILTER_PACKAGES_ERROR = "DELETE_ADMIN_FILTER_PACKAGES_ERROR";
